import React, { Component } from 'react'
import classNames from 'classnames'

import { emit } from '../../events'
import { CloseIcon, BackArrow } from '../SVGIcons'

import './Modal.css'

class Modal extends Component {

	componentDidMount() {
		emit('openmodal')
	}

	componentWillUnmount() {
		emit('closemodal')
	}

	scrollTop = () => {
		this.body.scrollTop = 0
	}

	render() {
		const {
			extraClassName,
			narrow,
			fullHeight = false,
			title,
			header,
			children,
			footer,
			mode = 'edit', // edit/show
			onCancel,
			onSave,
			saveText = 'Save'
		} = this.props

		const modeClass = (mode === 'edit') ? 'editMode' : 'showMode'
		const cancelText = (mode === 'edit') ? 'Cancel' : 'Close'

		return (
			<div
				className={classNames("Modal", { narrow: narrow, fullHeight: fullHeight }, modeClass, extraClassName)}>
				<div
					onClick={e => e.stopPropagation()}>
					<h1>{title}</h1>
					<div className="smallScreenTop">
						<div className="cancelButton" onClick={onCancel}>
							{ mode === 'edit' ? <CloseIcon /> : <BackArrow /> }
						</div>
						<span>{title}</span>
						{ mode === 'edit' && (
							<button className="saveButton" onClick={onSave}>{saveText}</button>
						)}
					</div>
					{header && (
						<header>{header}</header>
					)}
					<div className="body" ref={elem => { this.body = elem }}>
						{children}
					</div>
					<div className="actions">
						<button className="cancelButton" onClick={onCancel}>{cancelText}</button>
						{ mode === 'edit' && (
							<button className="saveButton" onClick={onSave}>{saveText}</button>
						)}
					</div>
					{footer && (
						<footer>{footer}</footer>
					)}
				</div>
			</div>
		)
	}
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js